(function (root, factory) {
  var engine = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = engine;
  }
  root.BudgetPlannerEngine = engine;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function sumBy(items, selector) {
    return (items || []).reduce(function (sum, item) {
      return sum + (selector(item) || 0);
    }, 0);
  }

  // Rounds a set of related percentages so they sum to the same whole number
  // that rounding their true combined total would produce, instead of each
  // percentage being rounded independently (which can under- or over-count
  // the group total by a point or two -- e.g. 33.3/33.3/33.4 independently
  // rounds to 33/33/33 = 99, even though the three categories consume
  // exactly 100% of income between them).
  function distributeRoundedPercentages(rawByKey) {
    var keys = Object.keys(rawByKey);
    var flooredByKey = {};
    var flooredSum = 0;
    var rawSum = 0;

    keys.forEach(function (key) {
      var floored = Math.floor(rawByKey[key]);
      flooredByKey[key] = floored;
      flooredSum += floored;
      rawSum += rawByKey[key];
    });

    var target = Math.round(rawSum);
    var deficit = target - flooredSum;

    if (deficit > 0) {
      keys
        .slice()
        .sort(function (a, b) {
          return (rawByKey[b] - flooredByKey[b]) - (rawByKey[a] - flooredByKey[a]);
        })
        .slice(0, deficit)
        .forEach(function (key) {
          flooredByKey[key] += 1;
        });
    } else if (deficit < 0) {
      keys
        .slice()
        .sort(function (a, b) {
          return (rawByKey[a] - flooredByKey[a]) - (rawByKey[b] - flooredByKey[b]);
        })
        .slice(0, -deficit)
        .forEach(function (key) {
          flooredByKey[key] -= 1;
        });
    }

    return flooredByKey;
  }

  function calculate(input) {
    var incomes = input.incomes || [];
    var expenses = input.expenses || [];
    var categories = input.categories || [];

    var totalIncome = sumBy(incomes, function (item) { return item.amount; });
    var totalExpenses = sumBy(expenses, function (item) { return item.amount; });
    var remaining = totalIncome - totalExpenses;

    var totalsByType = {
      needs: 0,
      wants: 0,
      savings: 0
    };

    var categoryTotals = {};

    expenses.forEach(function (expense) {
      var amount = expense.amount || 0;
      categoryTotals[expense.category] = (categoryTotals[expense.category] || 0) + amount;
      var category = categories.find(function (c) { return c.id === expense.category; });
      var type = category ? category.type : null;
      if (type && totalsByType[type] !== undefined) {
        totalsByType[type] += amount;
      }
    });

    var percentByType = { needs: 0, wants: 0, savings: 0 };
    if (totalIncome !== 0) {
      percentByType = distributeRoundedPercentages({
        needs: (totalsByType.needs / totalIncome) * 100,
        wants: (totalsByType.wants / totalIncome) * 100,
        savings: (totalsByType.savings / totalIncome) * 100
      });
    }

    var needsPercent = percentByType.needs;
    var wantsPercent = percentByType.wants;
    var savingsPercent = percentByType.savings;

    return {
      totalIncome: totalIncome,
      totalExpenses: totalExpenses,
      remaining: remaining,
      needsTotal: totalsByType.needs,
      wantsTotal: totalsByType.wants,
      savingsTotal: totalsByType.savings,
      needsPercent: needsPercent,
      wantsPercent: wantsPercent,
      savingsPercent: savingsPercent,
      categoryTotals: categoryTotals
    };
  }

  return { calculate: calculate };
});
